import React from "react"

import {FieldTableCellProps} from "../../../../../render/table/table-cell"
import Task from "../../../../../../model2/task/task"
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../../gd-components/buttons/control-button/control-button-standard"
import {isBulkSelection} from "../../../../../../gd/right-click-menu"
import TimerView from "../../../../../../gd-components/task-timer/timer"
import {ControlButtonSize} from "../../../../../../gd-components/buttons/control-button/@types";

// const debug = "FieldItemModelStoryPointsCalculated_TableCell"
const debug = false

type State = {
    isHovered   : boolean
}

export default class FieldItemModelTimeReportedCalculated_TableCell extends React.Component<FieldTableCellProps, State> {

    private isEditable  : boolean   = true

    constructor(props:FieldTableCellProps) {
        super(props)


        if (this.props.listItem.isProject) this.isEditable = false
        else {
            this.isEditable = !this.props.manager.isReadOnly && gd.ac.task.editStoryPoints(this.props.listItem.task)
        }

        this.state = {
            isHovered   : false,
        }
    }

    componentDidMount() {
        gd.bus.subscribe('task-timers:updated', this, this.timersUpdate)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    timersUpdate = (data?: {taskIds: ID[]}) => {
        if (data?.taskIds?.includes(this.props.listItem.task.id)) {
            this.forceUpdate()
        }
    }

    onMouseEnter = () => {
        if (!this.isEditable) return

        if (!this.props.listItem.isTask) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    checkTimerClickIsDisabled = (e: React.MouseEvent) => {
        return isBulkSelection(e)
    }

    onCloseTimer = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return

        e.stopPropagation()

        const task : Task = this.props.listItem.task
        gd.taskTimers.cancelTimer(task.id, ()=>{
            gd.taskTray.remove(task.id)
            this.forceUpdate()
        })
    }

    startTimer = (e: React.MouseEvent) => {
        // if (isBulkSelection(e)) return
        e.stopPropagation()
        gd.taskTimers.startTimer(this.props.listItem.task)
    }

    addTimeReport = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!this.isEditable) return

        const task : Task = this.props.listItem.task

        if (task.isTemplate) {
            const message = <div>This action is not available for template tasks.</div>;
            gd.modals.other.notification(message);
            return
        }

        gd.modals.myTime.timeReportForTask(task)
    }

    get style() {
        // this is common part for table cell
        // end common part

        const width = this.props.column.width ? this.props.column.width : this.props.manager.columnsManager.getColumnWidth(this.props.column)

        const style : style = _.clone(this.props.style) || {} // we need clone here because we add width!
        style.width = width

        return style
    }

    renderHovered() {
        const classes = Classes("cell-flex ui5-txt-less-important-small is-hovered", this.props.column.id,)

        let reportedTime        = 0
        let showSummary         = false

        // when collapsed show combined reported time from this item and its children
        // if (this.props.listItem.isCollapsed && this.props.listItem.childrenItems.length > 0) {
        if (this.props.listItem.isCollapsed && this.props.listItem.treeChildren.length > 0) {
            reportedTime = this.props.listItem.reported.total;
            showSummary = !!this.props.listItem.reported.children
        } else {
            reportedTime = this.props.listItem.reported.own;
        }

        const timer = gd.taskTimers.getTimer(this.props.listItem.task.id)

        return (
            <div className={classes} style={this.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>


                <div className="ui5-field-editable size-small is-hovered w-100-percent h-100-percent"
                     onClick={!timer ? this.addTimeReport : undefined}>

                    {!timer && <div className="flex-row-left-center truncate">
                        {reportedTime > 0 &&
                            <>
                                {showSummary && <div className="ui5-ico-12 i5-summary-symbol m-r-5"/>}
                                <span className="ui5-txt-less-important-small">{gd.utils.minutesHumanize(reportedTime)}</span>
                            </>
                        }
                    </div>}

                    {timer &&
                        <TimerView task             = {this.props.listItem.task}
                                   checkDisabled    = {this.checkTimerClickIsDisabled}
                                   onClose          = {this.onCloseTimer}
                                   size             = {ControlButtonSize.SIZE_24}
                                   showCancel       = {false}
                        />
                    }

                    <div className="buttons m-l-5">
                        {!timer &&
                            <ControlButtonStandard className    = "btn-add "
                                                   type         = {ControlButtonType.TIMER_PLAY}
                                                   size         = {24}
                                                   hint         = "Start timer"
                                                   onClick      = {this.startTimer} />
                        }

                        {!timer &&
                            <ControlButtonStandard className    = "btn-add "
                                               type         = {ControlButtonType.PLUS}
                                               size         = {24}
                                               hint         = "Add time report"
                                               onClick      = {this.addTimeReport} />
                        }
                    </div>

                </div>
            </div>
        )
    }

    renderNotHovered() {
        const classes = Classes("cell-flex flex-justify-start ui5-txt-less-important-small ui5-field-editable size-small", this.props.column.id)

        let reportedTime = 0
        let showSummary = false

        // when collapsed show combined reported time from this item and its children
        // if (this.props.listItem.isCollapsed && this.props.listItem.childrenItems.length > 0) {
        if (this.props.listItem.isCollapsed && this.props.listItem.treeChildren.length > 0) {
            reportedTime = this.props.listItem.reported.total
            showSummary = !!this.props.listItem.reported.children
        } else {
            reportedTime = this.props.listItem.reported.own
        }

        const showTimer = !!gd.taskTimers.getTimer(this.props.listItem.task.id)
        const showReportedTime = !showTimer && reportedTime > 0

        return (
            <div className      = {classes}
                 style          = {this.style}
                 onMouseEnter   = {this.onMouseEnter}
                 onMouseLeave   = {this.onMouseLeave}>

                {showReportedTime &&
                    <div className="flex-row-left-center truncate">
                        {showSummary && <div className="ui5-ico-12 i5-summary-symbol m-r-5"/>}
                        <span className="ui5-txt-less-important-small">{gd.utils.minutesHumanize(reportedTime)}</span>
                    </div>}

                {showTimer &&
                    <TimerView task             = {this.props.listItem.task}
                               checkDisabled    = {this.checkTimerClickIsDisabled}
                               onClose          = {this.onCloseTimer}
                               showCancel       = {false}
                               size             = {ControlButtonSize.SIZE_24} />
                    }
            </div>
        )

    }

    render() {
        debug && console.log(debug, "render() isHovered=", this.state.isHovered)

        // return this.renderHovered()

        if (this.state.isHovered) {
            return this.renderHovered()
        } else {
            return this.renderNotHovered()
        }
    }
}



